<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap v-for="video in newsVideos" :key="video._id">
      <v-flex xs12>
        <v-card class="news-happen__card" outlined tile>
          <div class="news-happen__card-container">
            <v-img
              @click="openVideo(video)"
              class="news-happen__img-container"
              :src="video.attachment | thumbnail"
            >
              <img src="@/assets/img/play.png" class="play" />
            </v-img>

            <div class="news-happen__card-container-description">
              <div class="news-happen__card-container-title">
                <h2>{{ video.title }}</h2>
                <span>{{ video.createdAt | parseDate }}</span>
              </div>

              <p>{{ video.description }}</p>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="560">
      <v-card v-if="selectedVideo">
        <v-card-title class="title">
          <span>{{ selectedVideo.title }}</span>
        </v-card-title>
        <div class="news-happen__video-container">
          <iframe
            :src="selectedVideo.attachment | embedUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click.native="dialog = false">{{
            $t('actions.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </module-page>
</template>

<script>
import moment from 'moment-timezone';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import newsVideoMixin from '@/mixins/newsVideo';
import { APP } from '@/utils/constants';
export default {
  name: 'news-awards',
  components: {
    ModulePage,
    ScreenLoading,
  },
  mixins: [newsVideoMixin],
  filters: {
    thumbnail(videoUrl) {
      const url = new URL(videoUrl);
      const query_string = url.search;
      const search_params = new URLSearchParams(query_string);
      const id = search_params.get('v');
      return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
    },
    embedUrl(videoUrl) {
      const url = new URL(videoUrl);
      const query_string = url.search;
      const search_params = new URLSearchParams(query_string);
      const id = search_params.get('v');
      return `https://www.youtube.com/embed/${id}`;
    },
    parseDate(v) {
      return moment(v).format('DD/MM/YYYY');
    },
  },
  computed: {},
  data() {
    return {
      selectedVideo: null,
      dialog: false,
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].newsHappen;
  },
  beforeDestroy() {},
  methods: {
    openVideo(video) {
      const title = video.title;
      const attachment = video.attachment;

      this.createTrace(this.enums.logTraceActions.linkNewsHappen, {
        title,
        attachment,
      });
      this.dialog = !this.dialog;
      this.selectedVideo = video;
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.selectedVideo = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.news-happen {
  @include breakpoint(mobile) {
    &__card-container {
      flex-direction: column;
    }

    &__card-container-description {
      width: auto !important;
    }
  }

  &__card {
    margin: 6px 0;
  }
  &__card-container {
    display: flex;
  }

  &__card-container-description {
    padding: 12px;
    width: calc(100% - 320px);
  }

  &__card-container-title {
    h2 {
      display: inline-block;
    }
    span {
      float: right;
    }
  }

  &__img-container {
    min-width: 320px;
    min-height: 180px;

    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }

    .play {
      position: relative;
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      margin: -40px 0 0 -40px;
    }
  }

  &__video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/Happen.vue